export default {
  couponReadList: {
    感謝惠顧: "Thank you for your purchase!",
    X已為你送上Y張優惠券: "{X} has sent you {Y} coupons.",
    有效期: "Validity Period:",
    查看優惠券: "View Coupon",
    關閉窗口: "Close Window",
  },
};
